import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { refreshCollections, confirmCollectionsDeletion } from '../actions';

const CollectionsActions = ({
  allowCreate,
  allowDelete,
  allowRefresh,
  category,
  code,
  disableDelete,
  readStatus,
  refresh,
  showDelete,
}) => (
  <>
    {allowCreate && (<CreateAction url={codeUrl(urls.COLLECTION, code, '#')} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={disableDelete} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  collections: { collections, newCollectionCode },
}, { category }) => {
  const { readStatus } = collections[category];
  const selected = findSelectedInCategory(collections, category);

  return {
    allowCreate: permissions.collections.create,
    allowDelete: permissions.collections.destroy,
    allowRefresh: permissions.datasets.read,
    code: newCollectionCode,
    disableDelete: readStatus === states.PENDING || selected.length === 0,
    readStatus,
  };
};

const mapDispatchToProps = {
  refresh: refreshCollections,
  showDelete: confirmCollectionsDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsActions);
